export interface Metric {
  value: string
  label: string
}

export const metrics: Metric[] = [
  {
    value: '$60M → $600M+',
    label: 'Revenue scale driven across enterprise software portfolios',
  },
  {
    value: '8+',
    label: 'Global M&A acquisitions integrated into a single product portfolio',
  },
  {
    value: '$2M+',
    label: 'First-quarter impact generated via Customer Advisory Boards',
  },
  {
    value: '25+ Years',
    label: 'Enterprise software, data and AI leadership',
  },
]
